import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=6f50c411&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"
import style0 from "./bottom.vue?vue&type=style&index=0&id=6f50c411&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f50c411",
  null
  
)

export default component.exports